<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="119.625px"
    height="28.906px"
    viewBox="0 0 119.625 28.906"
    enable-background="new 0 0 119.625 28.906"
    xml:space="preserve"
    fill="currentColor"
    :style="{ color: color }"
  >
    <g>
      <g>
        <path
          d="M46.454,1.273h-7.221c-1.016,0-1.814,0.797-1.814,1.814v22.954c0,1.018,0.799,1.815,1.814,1.815    c1.018,0,1.814-0.798,1.814-1.815v-9.045h5.406c4.746,0,7.695-3.021,7.695-7.881C54.149,4.278,51.2,1.273,46.454,1.273z     M50.483,9.115c0,2.846-1.605,4.477-4.402,4.477h-5.033V4.677h5.033C48.918,4.677,50.483,6.252,50.483,9.115z"
        />
        <path
          d="M70.857,16.791c0-1.308-0.369-7.843-7.693-7.843c-5.246,0-8.253,3.475-8.253,9.531    c0,6.257,2.984,9.564,8.626,9.564c3.783,0,5.852-1.879,6.227-2.257c0.297-0.296,0.572-0.651,0.572-1.243    c0-0.896-0.73-1.627-1.629-1.627c-0.465,0-0.725,0.148-0.998,0.333c-1.014,0.759-2.17,1.503-4.172,1.503    c-3.002,0-4.896-1.875-5.092-5.023H68.82C70.857,19.729,70.857,17.818,70.857,16.791z M63.164,12.203    c2.705,0,4.092,1.423,4.24,4.348h-8.921C58.854,13.746,60.512,12.203,63.164,12.203z"
        />
        <path
          d="M83.461,9.023c-2.121-0.001-3.668,0.73-4.76,1.794c-0.391-1.146-0.838-1.656-1.643-1.643    c-0.975,0.015-1.738,0.764-1.738,1.74v15.203c0,0.975,0.764,1.739,1.738,1.739s1.74-0.765,1.74-1.739v-8.391    c0-3.369,1.699-5.3,4.662-5.3c0.941,0,1.703-0.763,1.703-1.7C85.164,9.787,84.48,9.024,83.461,9.023z"
        />
        <path
          d="M95.645,0.822c-5.176,0-7.021,3.609-7.021,6.983v18.312c0,0.975,0.766,1.739,1.74,1.739    c0.977,0,1.74-0.765,1.74-1.739V12.803h2.867c0.932,0,1.664-0.732,1.664-1.663c0-0.936-0.732-1.667-1.664-1.667h-2.867V7.805    c0-2.423,1.191-3.652,3.541-3.652c0.932,0,1.664-0.73,1.664-1.666C97.309,1.554,96.576,0.822,95.645,0.822z"
        />
        <path
          d="M103.152,2.732c-1.268,0-1.963,0.726-1.963,2.038c0,1.214,0.75,1.968,1.963,1.968    c1.211,0,1.965-0.753,1.965-1.968C105.117,3.458,104.418,2.732,103.152,2.732z"
        />
        <path
          d="M103.152,9.174c-0.977,0-1.74,0.764-1.74,1.74v15.203c0,0.975,0.764,1.739,1.74,1.739    c0.975,0,1.738-0.765,1.738-1.739V10.914C104.891,9.938,104.127,9.174,103.152,9.174z"
        />
        <path
          d="M116.895,24.525c-1.053,0-1.631-0.683-1.631-1.932v-9.791h1.893c0.934,0,1.666-0.732,1.666-1.663    c0-0.936-0.732-1.667-1.666-1.667h-1.893V6.083c0-0.96-0.777-1.741-1.74-1.741c-0.926,0-1.74,0.814-1.74,1.741v16.511    c0,3.197,2.006,5.263,5.111,5.263c0.953,0,1.703-0.733,1.703-1.665C118.598,25.258,117.848,24.525,116.895,24.525z"
        />
      </g>
      <path
        d="M22.288,16.328v8.03c0,0.062-0.049,0.108-0.109,0.108H5.452c-0.061,0-0.109-0.047-0.109-0.108v-8.098   l-2.9-1.932v10.029c0,1.657,1.35,3.009,3.01,3.009h16.727c1.658,0,3.01-1.352,3.01-3.009v-9.972L22.288,16.328z"
      />
      <path
        d="M26.395,1.979c-0.227-0.421-0.666-0.685-1.146-0.685c-0.215,0-0.426,0.055-0.615,0.156L13.754,7.302   L2.995,1.533c-0.188-0.1-0.4-0.154-0.613-0.154c-0.479,0-0.92,0.264-1.148,0.686C0.899,2.689,1.129,3.469,1.747,3.816l11.361,7.579   l0.031,0.021c0.188,0.101,0.4,0.153,0.617,0.153c0.213,0,0.426-0.052,0.615-0.155l11.514-7.683   C26.502,3.386,26.733,2.604,26.395,1.979z"
      />
      <path
        d="M26.395,9.108c-0.227-0.424-0.666-0.685-1.146-0.685c-0.215,0-0.426,0.052-0.615,0.154l-10.879,5.852   L2.995,8.66c-0.188-0.1-0.4-0.153-0.613-0.153c-0.479,0-0.92,0.262-1.148,0.687c-0.162,0.305-0.199,0.656-0.1,0.99   c0.1,0.326,0.316,0.593,0.613,0.76l11.361,7.582l0.031,0.018c0.188,0.102,0.4,0.156,0.617,0.156c0.213,0,0.424-0.057,0.615-0.156   l11.514-7.683C26.502,10.513,26.733,9.735,26.395,9.108z"
      />
    </g>
  </svg>
</template>

<script lang="ts" setup>
//Props
withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: "#ffffff",
  }
);
</script>
